var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "col-sm-6 col-md-6" }, [
    _c("h2", [_vm._v(_vm._s(_vm.aboutsundair[_vm.getCurrentLocale]))]),
    _vm._v(" "),
    _c("p", [
      _c("strong"),
      _vm._v(" "),
      _c("span", {
        domProps: {
          innerHTML: _vm._s(_vm.aboutsundairtext[_vm.getCurrentLocale]),
        },
      }),
    ]),
    _vm._v(" "),
    _c("br"),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }